<template>
  <div class="recruitment_box">
    <div class="content_box">
      <div class="header">
        <div class="left_header">
          <el-cascader clearable ref="cascaderRef" :options="zymc" @change="changeJobType" :show-all-levels="false" v-model="poitionLabel" class="panel"></el-cascader>
          <el-select style="margin-left: 25px;" v-model="getParams.recruitment_type" placeholder="请选择工作性质" @change="getList">
            <el-option v-for="item in recruitmentOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="getParams.status" placeholder="请选择职位状态" @change="getList">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="right_header">
          <el-input v-model="getParams.keyword" class="input_box" @blur="getList" @keyup.enter="getList" placeholder="请输入"></el-input>
          <el-button class="post_button" @click="goPost">发布职位</el-button>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="tableData" style="width: 100%" height="62vh" :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#f5f7fa',height:'60px'}" :cell-style="{fontSize: '14px',color: '#333',height:'80px'}">
          <el-table-column prop="name" label="职位名称">
          </el-table-column>
          <el-table-column prop="city" label="地点">
          </el-table-column>
          <el-table-column prop="experience_type" label="工作经验">
          </el-table-column>
          <el-table-column prop="degree" label="学历要求">
          </el-table-column>
          <el-table-column prop="salary" label="薪资">
          </el-table-column>
          <el-table-column prop="recruitment_type" label="工作性质">
          </el-table-column>
          <el-table-column prop="apply_num" label="简历投递数">
          </el-table-column>
          <el-table-column prop="status" label="职位状态">
            <template slot-scope="scope">
              {{scope.row.status==1?'开启':'关闭' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button style="color: #685EF5;" type="text" @click="editPosition(scope.row)">编辑</el-button>
              <el-button style="color: #685EF5;" type="text" @click="changeStatus(scope.row)"> {{scope.row.status==1?'关闭':'开启' }}</el-button>
              <el-button style="color: #685EF5;" type="text" @click="viewPosition(scope.row)">预览</el-button>
              <el-button style="color:#FF0000;" type="text" @click="deletePosition(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px;display: flex;justify-content: end;">
          <el-pagination @current-change="handleCurrentChange" :current-page="getParams.page" :page-size="getParams.page_size" layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <ViewPositionDraw ref="viewPositionRef" :position_info="position_info" :value="drawerVisible" @closeDrawer="closeDrawer" />
  </div>
</template>

<script>
import zymc from "../../../utils/zymc.json";
import ViewPositionDraw from "../../../components/companyModule/ViewPositionDraw.vue";
export default {
  name: "",
  components: { ViewPositionDraw },
  data() {
    return {
      getParams: {
        page: 1,
        page_size: 10,
        position_type: "",
        recruitment_type: 0,
        status: 0,
        keyword: "",
      },
      poitionLabel: [],
      positionOption: [],
      statusOption: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "开启",
          value: 1,
        },
        {
          label: "关闭",
          value: 2,
        },
      ],
      recruitmentOption: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "全职",
          value: 1,
        },
        {
          label: "兼职",
          value: 2,
        },
      ],
      tableData: [],
      zymc: zymc,
      position_info: {},
      drawerVisible: false,
       total:0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
     handleCurrentChange(val) {
      this.getParams.page = val;
      this.getList();
    },
    goPost() {
      this.$router.push("/company/post/position");
    },
    getList() {
      this.$httpcompany.axiosGetBy(
        this.$api.positionManagePositionList,
        this.getParams,
        (res) => {
          if (res.code == 200) {
            this.tableData = res.data.list;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    changeJobType(val) {
      let arr = this.$refs.cascaderRef.getCheckedNodes();
      this.getParams.position_type = arr[0].label;
      this.getList();
    },
    editPosition(row) {
      this.$router.push({
        path: "/company/post/position",
        query: { id: row.id },
      });
    },
    changeStatus(row) {
      let params = {
        id: row.id,
        status: row.status == 1 ? 2 : 1,
      };
      this.$httpcompany.axiosPost(
        this.$api.positionManagePositionStatus,
        params,
        (res) => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    viewPosition(row) {
      this.drawerVisible = true;
      Object.assign(this.position_info, row);
      this.$refs.viewPositionRef?.getDetial();
      //   getDetial
    },
    deletePosition(row) {
      this.$confirm("是否删除该职位？删除后将无法恢复", "删除提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        customClass: "ek-confirm warning",
      }).then(() => {
        const params = { id: row.id };
        this.$httpcompany.axiosPost(
          this.$api.positionManageDeletePosition,
          params,
          (res) => {
            if (res.code === 200) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          }
        );
      });
    },
    // 打开弹框
    // 关闭弹框

    closeDrawer() {
      this.drawerVisible = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.recruitment_box {
  width: 100%;
  height: calc(100vh - 100px);
  padding: 20px 20px 40px 20px;
  box-sizing: border-box;
  .content_box {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    .header {
      padding: 30px 40px 20px 40px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_header {
        display: flex;
        align-items: center;
        .el-select {
          width: 240px;
          height: 40px;
          margin-right: 24px;
        }
      }
      .right_header {
        display: flex;
        align-items: center;
        .input_box {
          width: 240px;
          height: 36px;
          margin-right: 24px;
        }
        .post_button {
          width: 88px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background: #685ef5;
          color: #ffffff;
        }
      }
    }
    .table_box {
      padding: 30px 40px 20px 40px;
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
